export default __webpack_public_path__ + "static/media/1.16c7574c.png";